import { Session } from 'services';
import { TEACHER_CONFIRMED_YES } from '../constants';

export const isConfirmed = (session: Session) => {
  return Boolean(session?.teacherConfirmed === TEACHER_CONFIRMED_YES);
};
export const isAddedContent = (session: Session) => {
  return Boolean(
    session?.vocabulary &&
      session?.studentNote &&
      session?.title &&
      session?.grammar,
  );
};
export const customRound = (number: number) => {
  var roundedNumber = Math.floor(number); // Round down to the nearest integer
  var decimalPart = +(number - roundedNumber); // Extract the decimal part

  if (decimalPart >= 0.3 && decimalPart < 0.8) {
    return roundedNumber + 0.5;
  } else if (decimalPart < 0.3) {
    return roundedNumber;
  } else if (decimalPart >= 0.8) {
    return Math.ceil(number);
  } else {
    return 0;
  }
};
